import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global/selectors'
import { type TermsMethodsKindEnum } from '@webapp/modules/purchasing/entities/enums'

export type CustomizePurchaseOrderFormTab =
  | 'disclaimer'
  | TermsMethodsKindEnum
  | 'po-pdf-labels'
  | 'po-pdf-custom-fields'

/**
 * Orchestration hook for CustomizePurchaseOrderFormView.
 *
 * Owns the URL-derived tab state (`/settings/customfields-po/:tab?`, absent →
 * `disclaimer` — custom field management moved to the Main Custom Field Setup
 * page, PLAT-4936) and the `enable_auto_po` composition gate for the External
 * PO Numbering card (BHV-003). The CQS bridge between the preference query
 * hook and the toggle presenter lives in the gated card section so the query
 * hook is never called while the switch is off.
 */
export const useCustomizePurchaseOrderFormView = () => {
  const { tab } = useParams<{ tab?: CustomizePurchaseOrderFormTab }>()
  const activeTab: CustomizePurchaseOrderFormTab = tab ?? 'disclaimer'

  const { enable_auto_po } = useSelector(makeSelectFeatureSwitches())

  return {
    states: {
      activeTab,
      showExternalPONumbering: Boolean(enable_auto_po),
    },
  }
}
